export default __webpack_public_path__ + "static/media/Faq.fce2e0a8.png";